var paymentTypes = [{
  flag: '',
  title: 'Basic',
  blurb: 'Get online with 0 effort',
  pricing: {
    description: '<span>$17</span>/mo, billed annually',
    subdescription: 'or $20/mo, billed monthly'
  },
  annual: {
    price: 200
  },
  monthly: {
    price: 20
  },
  qualitiesTitle: 'Key Features',
  listOfQualities: ['Free Custom Domain', 'Mobile Optimized Design', 'Customer Support - Email', 'Essential Search Engine Optimization'],
  listOfQualitiesWebsiteOnly: ['Included Content: Logo, Menu, Images, About Description, ' + 'Hours of Operation, Contact Info, External Links, Reviews', 'Photo or Digital Menu Page']
}, {
  flag: '',
  title: 'Standard',
  blurb: 'Get found online by more customers',
  pricing: {
    description: '<span>$30</span>/mo, billed annually',
    subdescription: 'or $35/mo, billed monthly'
  },
  annual: {
    price: 350
  },
  monthly: {
    price: 35
  },
  qualitiesTitle: 'Key Features',
  listOfQualities: ['Content Editor Access', 'Digital Menu Conversion', 'Update Fonts and Colors', 'Up to 2 Locations', 'Google My Business Management'],
  listOfQualitiesWebsiteOnly: ['Promotional Pop-ups and Banners', 'Promote Menu Specials']
}, {
  flag: 'BEST VALUE',
  title: 'Professional',
  blurb: 'Make your website stand out',
  pricing: {
    description: '<span>$42</span>/mo, billed annually',
    subdescription: 'or $50/mo, billed monthly'
  },
  annual: {
    price: 500
  },
  monthly: {
    price: 50
  },
  qualitiesTitle: 'Everything in Standard +',
  listOfQualities: ['Website Analytics', 'Customer Lead Collection (CRM)', 'Up to 2 Additional Pages *', 'Up to 5 Locations', 'Support for 3rd Party Widgets'],
  listOfQualitiesWebsiteOnly: ['Advanced Search Engine Optimization', 'User-Triggered ADA Compliance', 'Blog', 'New Designs (coming soon)']
}, {
  flag: '',
  title: 'Custom',
  blurb: 'Get a customized design',
  pricing: {
    description: "<span>Let's talk</span>",
    subdescription: ''
  },
  annual: {
    price: 0
  },
  monthly: {
    price: 0
  },
  qualitiesTitle: 'Everything in Pro +',
  listOfQualities: ['Unlimited Locations', 'Custom Design', 'HD Photography']
}];
var CUSTOM_PLAN_INDEX = paymentTypes.length - 1;
export { paymentTypes, CUSTOM_PLAN_INDEX };